import apiClient from "../client";

// GET /api/users/me
// Called after login to get role, MAC assignment, and display info
// Returns: { userId, fullName, email, role, isActive, macId, macCode, macName }
export const getCurrentUser = async () => {
  const response = await apiClient.get("/users/me");
  return response.data;
};